var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goal-icon",style:({background: _vm.returnBackgroungColor(_vm.title), height: _vm.height + 'px', minWidth: _vm.width + 'px'})},[_c('img',{attrs:{"src":require(`@/assets/goalIcon/${_vm.returnGoalIcon(_vm.title)}`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }